import styled from 'styled-components';

export const NgPanelHeader = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 8px 4px;
`;
